import styled from "styled-components";

const Icon = ({width, height, background, margin, cursor, onClick}) => {
    return (
        <IconWrap background={background} width={width} height={height} margin={margin} cursor={cursor} onClick={onClick}/>
    )
}

const IconWrap = styled.i`
  display: block;
  width: ${({width}) => width};;
  height: ${({height}) => height};;
  background: ${({background}) => background};
  margin: ${({margin}) => margin};
  cursor: ${({cursor}) => cursor};
`;

export default Icon;